import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Box from '@mui/material/Box';

import SearchableDropdown, {
  SEARCHABLE_DROPDOWN_VARIANT,
} from '../../../components/SearchableDropdown';

import FormFieldRow from './FormFieldRow';
import RequirementChip from './RequirementChip';

const getOptionLabel = (option) => option?.name || '';

const RequirementPicker = ({
  labelKey,
  placeholderKey,
  helperKey,
  optionsCallback,
  selected = [],
  onChange,
  testId,
}) => {
  const placeholder = LanguageConverterV2(placeholderKey);

  const handleAdd = (event, option) => {
    if (!option || selected.some((item) => item._id === option._id)) return;
    onChange([...selected, option]);
  };

  const handleRemove = (id) => onChange(selected.filter((item) => item._id !== id));

  return (
    <FormFieldRow labelKey={labelKey} helperKey={helperKey}>
      {selected.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
          {selected.map((item) => (
            <RequirementChip
              key={item._id}
              label={getOptionLabel(item)}
              onDelete={() => handleRemove(item._id)}
            />
          ))}
        </Box>
      )}
      <SearchableDropdown
        value={null}
        onChange={handleAdd}
        optionsAPICallback={optionsCallback}
        getOptionLabel={getOptionLabel}
        placeholder={placeholder}
        variant={SEARCHABLE_DROPDOWN_VARIANT.SEARCH}
        excludeIds={selected.map((item) => item._id)}
        testId={testId}
      />
    </FormFieldRow>
  );
};

RequirementPicker.propTypes = {
  labelKey: PropTypes.string.isRequired,
  placeholderKey: PropTypes.string.isRequired,
  helperKey: PropTypes.string,
  optionsCallback: PropTypes.shape({
    httpMethod: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    generateBody: PropTypes.func.isRequired,
  }).isRequired,
  selected: PropTypes.arrayOf(PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string })),
  onChange: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

export default RequirementPicker;
